dmx.bs5toast = {
    defaults: {
        iconType: 'image',
        position: 'top',
        align: 'right',
        'offset-x': 15,
        'offset-y': 15,
        'z-index': 10000,
        'min-width': 240,
        'max-width': 350,
        animation: true,
        autohide: true,
        closable: true,
        delay: 5000
    },

    container: null,

    setup: function(options) {
        options = Object.assign(dmx.bs5toast.defaults, options);

        if (!dmx.bs5toast.container) {
            dmx.bs5toast.container = document.createElement('div');
            document.body.appendChild(dmx.bs5toast.container);
        }

        var container = dmx.bs5toast.container;
        container.style.removeProperty('top');
        container.style.removeProperty('left');
        container.style.removeProperty('right');
        container.style.removeProperty('bottom');
        container.style.removeProperty('max-width');
        container.style.setProperty('position', 'fixed');
        container.style.setProperty('z-index', options['z-index']);
        container.style.setProperty(options.align, options['offset-x'] + 'px');
        container.style.setProperty(options.position, options['offset-y'] + 'px');
        if (options['max-width']) {
            container.style.setProperty('max-width', options['max-width'] + 'px');
        }
    },

    clear: function() {
        if (dmx.bs5toast.container) {
            dmx.bs5toast.container.textContent = '';
        }
    },

    show: function(options) {
        options = Object.assign({}, dmx.bs5toast.defaults, options);

        if (!dmx.bs5toast.container) {
            dmx.bs5toast.setup();
        }

        var node = dmx.bs5toast.create(options);
        dmx.bs5toast.container.appendChild(node);

        //$(node).toast(options).toast('show').on('hidden.bs.toast', function() {
        var toast = new bootstrap.Toast(node, options);
        node.addEventListener('hidden.bs.toast', function() {
            dmx.bs5toast.container.removeChild(node);
        });
        toast.show();
    },

    create: function(options) {
        var html = '<div class="toast"' + (options['min-width'] ? ' style="min-width: ' + options['min-width'] + 'px"' : '') + ' role="alert" aria-live="assertive" aria-atomic="true" data-bs-delay="' + (options.delay || this.props.delay) + '">';
        if (options.icon || options.title || options.subtitle || options.closable) {
            html += '<div class="toast-header">';
            if (options.icon) {
                switch (options.iconType) {
                    case 'fontawesome':
                        html += '<i class="' + options.icon + ' me-2"></i>';
                        break;
                    default:
                        html += '<img src="' + options.icon + '" height="20" class="rounded me-2" alt="' + (options.alt || '') + '">';
                        break;
                }
            }
            html += '<strong class="me-auto">' + (options.title || '') + '</strong>';
            if (options.subtitle) {
                html += '<small class="text-muted">' + (options.subtitle) + '</small>';
            }
            if (options.closable) {
                html += '<button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>';
            }
            html += '</div>';
        }
        html += '<div class="toast-body">' + (options.message || '') + '</div>';
        html += '</div>';

        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        return tmp.firstChild;
    }
};